import { tr } from '@repo/locale';
import { ConsentPathGuard } from '@repo/privacy-consent';
import { TestId } from '@repo/test-id';
import { Outlet } from 'react-router-dom';

export default function ParkingCreateConsentGuard() {
  const testId = TestId.root('parkingCreateConsentGuard');

  return (
    <ConsentPathGuard
      service={['parkingCreate', 'googleReverseGeocode']}
      title={tr('owned_parking_create:consent_guard.title')}
      testId={testId}
    >
      <Outlet />
    </ConsentPathGuard>
  );
}
